module.exports = __webpack_public_path__ + "static/media/logo-full.fbd0aa8c.png";